import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-base min-h-[100dvh] md:min-h-0 overflow-hidden md:overflow-visible flex flex-col pt-3 md:pt-4 pb-4 md:pb-6 px-4" data-id="element-203">
      <div className="max-w-[640px] w-full mx-auto flex flex-col items-center text-center flex-1 justify-between md:justify-start md:gap-0" data-id="element-204">
        <div className="flex flex-col items-center w-full" data-id="element-205">
          <div className="mb-3" data-id="element-206">
            <div className="inline-flex items-center gap-2 bg-brand-green/10 border-[1.5px] border-brand-green text-brand-green font-display text-[11px] sm:text-[11px] font-semibold tracking-[1.5px] py-1.5 px-4 rounded-full uppercase" data-id="element-207">
              🌿 IMPULSO DIGITAL™
            </div>
          </div>

          <h1 className="font-display text-[22px] sm:text-[28px] md:text-[36px] font-bold text-white mb-2 leading-[1.1] uppercase" data-id="element-208">
            <span className="text-brand-green" data-id="element-209">
              Adelgazá, desinflamá y desinchate hasta 5kg en los primeros 7
              días.
            </span>
            <br data-id="element-210" />
            <span className="text-brand-red block mt-1" data-id="element-211">
              Sin dieta, sin remedios, sin gimnasio.
            </span>
          </h1>

          <p className="font-display text-base sm:text-lg font-bold text-white tracking-[1px] uppercase" data-id="element-212">
            Listo. Desde hoy.
          </p>
        </div>

        <div className="w-full flex items-center justify-center my-2 md:my-3" data-id="element-213">
          <img src="https://cdn.magicpatterns.com/uploads/1ivW8uYYJK5MNk3XtDWvWB/ChatGPT_Image_29_may_2026,_19_30_45.png" alt="Megapack Cuerpo Nuevo después de los 40" loading="eager" className="max-h-[30vh] w-auto md:max-h-none md:w-full md:max-w-[400px] h-auto object-contain" data-id="element-214" />
        </div>

        <div className="flex flex-col items-center w-full" data-id="element-215">
          <p className="text-[13px] sm:text-[14px] leading-snug mb-3 max-w-[500px]" data-id="element-216">
            <span className="text-brand-green font-bold" data-id="element-217">El sistema N°1</span>
            <span className="text-white" data-id="element-218">
              {' '}
              que reactiva tu metabolismo en la menopausia comiendo 3 a 4 veces
              por día, sin dietas extremas ni pasar hambre.
            </span>
          </p>

          <div className="flex flex-wrap gap-1.5 mb-3 justify-center" data-id="element-219">
            {['📄 100% PDF', '⚡ 5 min', '📚 6 Tomos', '🎁 6 Bonos'].map(chip => <span key={chip} className="bg-white/5 border border-white/10 text-white/80 text-[11px] sm:text-xs py-1 px-2.5 rounded-full whitespace-nowrap" data-id="element-220">
                  {chip}
                </span>)}
          </div>

          <button onClick={scrollToPricing} className="block w-full max-w-[420px] bg-brand-green text-white font-display text-base sm:text-lg font-bold tracking-[1px] py-3 px-6 rounded-lg text-center uppercase border-none cursor-pointer transition-transform hover:-translate-y-0.5 mb-2 shadow-[0_0_24px_rgba(0,200,83,0.3)]" data-id="element-221">
            🔥 QUIERO MI MEGAPACK AHORA
          </button>

          <p className="text-[11px] sm:text-xs text-brand-muted" data-id="element-222">
            ✅ Garantía 7 días &nbsp;·&nbsp; 🔒 Pago 100% seguro &nbsp;·&nbsp;
            💳 MercadoPago
          </p>
        </div>
      </div>
    </section>;
}